import React from "react";
import { Navigate } from "react-router-dom";
import { useAccount } from "~/hooks/useAccount";
import SuspenseFallback from "~/components/layout/SuspenseFallback";

interface IProps {
  render: React.ReactNode;
  guest?: boolean;
  to?: string;
}

const RouteGuard: React.FC<IProps> = ({ render, guest = false, to }) => {
  // Login state can no longer be read synchronously from localStorage — the
  // auth token lives in an HttpOnly cookie, invisible to JS. useAccount()
  // resolves it by calling GET auth/user/, which succeeds or 401s based on
  // the cookie the browser sends automatically.
  const { account, isLoading } = useAccount();
  const isAuthenticated = !!account;

  if (isLoading) return <SuspenseFallback />;
  if (guest ? !isAuthenticated : isAuthenticated) return <>{render}</>;
  if (!to) return null; // when implementing login, redirect to login, if "to" is not set
  return <Navigate to={{ pathname: to }} />;
};

export default RouteGuard;
